import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/core/templates/empty_template.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../renderer";
import { TemplateBase } from "./template_base";
export var EmptyTemplate =
/*#__PURE__*/
function (_TemplateBase) {
  _inherits(EmptyTemplate, _TemplateBase);

  function EmptyTemplate() {
    _classCallCheck(this, EmptyTemplate);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyTemplate).apply(this, arguments));
  }

  _createClass(EmptyTemplate, [{
    key: "_renderCore",
    value: function _renderCore() {
      return $();
    }
  }]);

  return EmptyTemplate;
}(TemplateBase);